


















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/tenugui/PopupTemplate.vue'
import QuizTenugui from '@/views/organisms/QuizTenugui.vue'

export default
  components: {
    PopupTemplate
    QuizTenugui
  }

  data: () ->
    baseColor: '#4D2095'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        '私たちが目指すてぬぐいとは'
        '次のうちどれでしょうか？'
      ]
      quiz: [
        '次世代につなぐ進化したてぬぐい'
        '伝統を守るてぬぐい'
        'デザイン性を売りにしたてぬぐい'
      ]
      success_message: [
        '進化したてぬぐいをつくることによって、'
        'より幅広い方に「てぬぐいの良さ」を知ってもらい、'
        '次世代につなぎたいと考えています。'
      ]
      answer: 1

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p2-2'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
